import React from 'react';
import '../../components/BotRegisteredManagementTable/BotRegisteredManagementTable.scss';
import { Container } from 'react-bootstrap';
import BotRegisteredManagementTable from 
'../../components/BotRegisteredManagementTable/BotRegisteredManagementTable';
import {
  getRegisteredBotRequestAction,
  sortBotHistorySortData,
  sortingBotHistoryAction,
} from '../../store/bot/botActions';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { 
  Bot, 
  Settings, 
  Activity,
  Database
} from 'lucide-react';

function BotManagementRegistered({ ...props }) {
  const {
    botHistorySortData,
    setSortData,
    sortingBotHistory,
    registeredBotData,
    getRegisteredBotRequest,
  } = props;

  useEffect(() => {
    getRegisteredBotRequestAction();
  }, [botHistorySortData]);
  
  useEffect(() => {
    getRegisteredBotRequest();
  }, []);

  function changeSortType(sortType) {
    const newBotHistorySortData = { ...botHistorySortData, sortType };
    setSortData(newBotHistorySortData);
    sortingBotHistory();
  }

  function changeSortKey(sortKey) {
    const newBotHistorySortData = { ...botHistorySortData, sortKey };
    setSortData(newBotHistorySortData);
    sortingBotHistory();
  }

  // Calculate stats
  const registeredBots = registeredBotData ? Object.values(registeredBotData) : [];
  const activeBots = registeredBots.filter(bot => bot.registration_status === true).length;
  const totalInvestment = registeredBots.reduce((sum, bot) => sum + (bot.investment || 0), 0);

  return (
    <div className="modern-bot-management-registered">
      <Container>
        {/* Modern Header */}
        <div className="management-header-section">
          <div className="header-content">
            <div className="header-left">
              <div className="management-title">
                <Bot size={32} className="title-icon" />
                <h1>Registered Bot Management</h1>
              </div>
              <p className="management-subtitle">
                Manage and monitor your active trading bots
              </p>
            </div>
            
            <div className="header-stats">
              <div className="stat-card">
                <div className="stat-icon">
                  <Activity size={20} />
                </div>
                <div className="stat-content">
                  <span className="stat-number">{activeBots}</span>
                  <span className="stat-label">Active Bots</span>
                </div>
              </div>
              
              <div className="stat-card">
                <div className="stat-icon">
                  <Database size={20} />
                </div>
                <div className="stat-content">
                  <span className="stat-number">{registeredBots.length}</span>
                  <span className="stat-label">Total Bots</span>
                </div>
              </div>
              
              <div className="stat-card">
                <div className="stat-icon">
                  <Settings size={20} />
                </div>
                <div className="stat-content">
                  <span className="stat-number">${totalInvestment.toLocaleString()}</span>
                  <span className="stat-label">Total Investment</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modern Table Container */}
        <div className="table-section">
          <BotRegisteredManagementTable />
        </div>
      </Container>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    botHistoryData: state.botReducer.botHistoryData,
    botStatisticsData: state.botReducer.botStatisticsData,
    botHistorySortData: state.botReducer.botHistorySortData,
    isLoading: state.loadingReducer.isLoading,
    user: state.userReducer.user,
    registeredBotData: state.botReducer.registeredBotData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSortData: (payload) => {
      dispatch(sortBotHistorySortData(payload));
    },
    sortingBotHistory: (payload) => {
      dispatch(sortingBotHistoryAction(payload));
    },
    getRegisteredBotRequestAction: (payload) => {
      dispatch(getRegisteredBotRequestAction(payload));
    },
    getRegisteredBotRequest: (payload) => {
      dispatch(getRegisteredBotRequestAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BotManagementRegistered);